import React, { PureComponent } from 'react';

import { Message, Attachment } from 'models';
import MessageWithLinks from 'shared/components/MessageWithLinks';

import styles from './styles';
import ChatMessageWithAttachment from '../ChatMessageWithAttachment';

export default class ChatMessageForCustomer extends PureComponent {
  render() {
    const { attachment, message } = this.props;
    let style = styles.message;
    if (message.loading || message.failed) {
      style = Object.assign({}, style, styles.loading);
    }

    if (message.attachments && message.attachments.length) {
      return (
        <ChatMessageWithAttachment
          attachment={attachment}
          className="customerMessage"
          message={message}
          style={style}
        />
      );
    }

    return (
      <p style={style} className="customerMessage kustomer-app-thread-customer-message">
        <MessageWithLinks text={message.body} />
      </p>
    );
  }
}

ChatMessageForCustomer.propTypes = {
  message: React.PropTypes.instanceOf(Message),
  attachment: React.PropTypes.instanceOf(Attachment),
};

ChatMessageForCustomer.defaultProps = {
  message: Message(),
  attachment: Attachment(),
};
